// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var CustomMap$SmartcutsMacros = require("./CustomMap.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var CommandLog$SmartcutsMacros = require("./CommandLog.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");

function t_encode(v) {
  if (v.TAG === /* InstalledSmartcutPointer */0) {
    return [
            "InstalledSmartcutPointer",
            SmartcutIds$SmartcutsMacros.installedSmartcutId_encode(v._0)
          ];
  } else {
    return [
            "SmartcutPointer",
            SmartcutIds$SmartcutsMacros.smartcutId_encode(v._0)
          ];
  }
}

function t_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "InstalledSmartcutPointer" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* InstalledSmartcutPointer */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SmartcutPointer" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = SmartcutIds$SmartcutsMacros.smartcutId_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SmartcutPointer */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function getSmartcutPageUrl(v) {
  if (v.TAG === /* InstalledSmartcutPointer */0) {
    return "/app/my_smartcuts/" + v._0;
  } else {
    return "/smartcuts/" + v._0;
  }
}

function stringify(v) {
  if (v.TAG === /* InstalledSmartcutPointer */0) {
    return "InstalledSmartcutPointer(" + v._0 + ")";
  } else {
    return "SmartcutPointer(" + v._0 + ")";
  }
}

var SmartcutOrInstalledSmartcutPointer = {
  t_encode: t_encode,
  t_decode: t_decode,
  getSmartcutPageUrl: getSmartcutPageUrl,
  stringify: stringify
};

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "loginBeforeStepIds",
                Decco.arrayToJson(Decco.intToJson, v.loginBeforeStepIds)
              ],
              [
                "smartcutOrInstalledSmartcutPointer",
                t_encode(v.smartcutOrInstalledSmartcutPointer)
              ],
              [
                "smartcutName",
                Decco.stringToJson(v.smartcutName)
              ],
              [
                "commandLog",
                CommandLog$SmartcutsMacros.GlobalForPlayback.t_encode(v.commandLog)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var loginBeforeStepIds = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginBeforeStepIds"), null));
  if (loginBeforeStepIds.TAG === /* Ok */0) {
    var smartcutOrInstalledSmartcutPointer = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutOrInstalledSmartcutPointer"), null));
    if (smartcutOrInstalledSmartcutPointer.TAG === /* Ok */0) {
      var smartcutName = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutName"), null));
      if (smartcutName.TAG === /* Ok */0) {
        var commandLog = CommandLog$SmartcutsMacros.GlobalForPlayback.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "commandLog"), null));
        if (commandLog.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    loginBeforeStepIds: loginBeforeStepIds._0,
                    smartcutOrInstalledSmartcutPointer: smartcutOrInstalledSmartcutPointer._0,
                    smartcutName: smartcutName._0,
                    commandLog: commandLog._0
                  }
                };
        }
        var e = commandLog._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".commandLog" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = smartcutName._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".smartcutName" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = smartcutOrInstalledSmartcutPointer._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".smartcutOrInstalledSmartcutPointer" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = loginBeforeStepIds._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".loginBeforeStepIds" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function minify(param) {
  return {
          loginBeforeStepIds: param.loginBeforeStepIds,
          smartcutOrInstalledSmartcutPointer: param.smartcutOrInstalledSmartcutPointer,
          smartcutName: param.smartcutName,
          commandLog: CommandLog$SmartcutsMacros.GlobalForPlayback.minify(param.commandLog)
        };
}

var SmartcutNameAndCommandLogData = {};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "smartcutOrInstalledSmartcutPointer",
                t_encode(v.smartcutOrInstalledSmartcutPointer)
              ],
              [
                "version",
                Decco.intToJson(v.version)
              ],
              [
                "loginBeforeStepIds",
                Decco.arrayToJson(Decco.intToJson, v.loginBeforeStepIds)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var smartcutOrInstalledSmartcutPointer = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "smartcutOrInstalledSmartcutPointer"), null));
  if (smartcutOrInstalledSmartcutPointer.TAG === /* Ok */0) {
    var version = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "version"), null));
    if (version.TAG === /* Ok */0) {
      var loginBeforeStepIds = Decco.arrayFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "loginBeforeStepIds"), null));
      if (loginBeforeStepIds.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  smartcutOrInstalledSmartcutPointer: smartcutOrInstalledSmartcutPointer._0,
                  version: version._0,
                  loginBeforeStepIds: loginBeforeStepIds._0
                }
              };
      }
      var e = loginBeforeStepIds._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".loginBeforeStepIds" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = version._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".version" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = smartcutOrInstalledSmartcutPointer._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".smartcutOrInstalledSmartcutPointer" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var Ref = {
  t_encode: t_encode$2,
  t_decode: t_decode$2
};

function toRef(param) {
  return {
          smartcutOrInstalledSmartcutPointer: param.smartcutOrInstalledSmartcutPointer,
          version: 1,
          loginBeforeStepIds: param.loginBeforeStepIds
        };
}

function t__encode(v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_encode, t_encode$1), v);
}

function t__decode(v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_decode, t_decode$1), v);
}

function castFromMap(x) {
  return x;
}

function isEmpty(v) {
  return Belt_MapString.size(v) === 0;
}

function minify$1(map1) {
  return Belt_MapString.map(map1, (function (map2) {
                return Belt_Map.map(map2, minify);
              }));
}

function hasAnyLoginSmartcuts(loginSmartcutsByHostnameAndScenario) {
  return Belt_MapString.some(loginSmartcutsByHostnameAndScenario, (function (_hostname, map) {
                return Belt_Map.size(map) > 0;
              }));
}

function hasNoLoginSmartcutsForHostname(loginSmartcutsByHostnameAndScenario, hostname) {
  var mapLoginScenario = Belt_MapString.get(loginSmartcutsByHostnameAndScenario, hostname);
  if (mapLoginScenario !== undefined) {
    return Belt_Map.size(Caml_option.valFromOption(mapLoginScenario)) === 0;
  } else {
    return true;
  }
}

function toRefsByHostnameAndScenario(loginSmartcutsByHostnameAndScenario) {
  return Belt_MapString.map(loginSmartcutsByHostnameAndScenario, (function (map) {
                return Belt_Map.map(map, toRef);
              }));
}

function getHostnamesWithAtLeastOneLoginSmartcut(loginSmartcutsByHostnameAndScenario) {
  return Belt_Array.keepMap(Belt_MapString.toArray(loginSmartcutsByHostnameAndScenario), (function (param) {
                var _n = Belt_Map.size(param[1]);
                if (_n !== 0) {
                  return param[0];
                }
                
              }));
}

function getPairsOfLoginScenarioAndLoginSmartcutForHostname(loginSmartcutsByHostnameAndScenario, hostname) {
  var arg = Belt_Option.map(Belt_MapString.get(loginSmartcutsByHostnameAndScenario, hostname), Belt_Map.toArray);
  var param = [];
  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}

function concatAllLoginCommandLogsIntoSingleCommandLog(smartcutLoginsByHostnameAndScenario) {
  var arg = Belt_MapString.valuesToArray(smartcutLoginsByHostnameAndScenario);
  return Belt_List.concatMany(Belt_Array.map((function (param) {
                      return ArrayUtils$SmartcutsMacros.flatMap(param, arg);
                    })(Belt_Map.valuesToArray), (function (param) {
                    return param.commandLog;
                  })));
}

function prependCommandsToCommandLog(smartcutLoginsByHostnameAndScenario, commandLog) {
  return List.append(concatAllLoginCommandLogsIntoSingleCommandLog(smartcutLoginsByHostnameAndScenario), commandLog);
}

function reduce(smartcutLoginsByHostnameAndScenario, init, f) {
  return Belt_MapString.reduce(smartcutLoginsByHostnameAndScenario, init, (function (accum, hostname, loginSmartcutByLoginScenario) {
                return Belt_Map.reduce(loginSmartcutByLoginScenario, accum, (function (accum, loginScenario, loginSmartcut) {
                              return Curry._4(f, accum, hostname, loginScenario, loginSmartcut);
                            }));
              }));
}

function removeLoginSmartcutForHostname(smartcutLoginsByHostnameAndScenario, hostname, loginSmartcutAsSmartcutOrPointer) {
  var map = Belt_MapString.get(smartcutLoginsByHostnameAndScenario, hostname);
  if (map === undefined) {
    return Belt_MapString.remove(smartcutLoginsByHostnameAndScenario, hostname);
  }
  var map$1 = Caml_option.valFromOption(map);
  if (Belt_Map.size(map$1) <= 0) {
    return Belt_MapString.remove(smartcutLoginsByHostnameAndScenario, hostname);
  }
  var emptyMap = Belt_Map.keep(map$1, (function (_key, param) {
          return Caml_obj.caml_notequal(param.smartcutOrInstalledSmartcutPointer, loginSmartcutAsSmartcutOrPointer);
        }));
  if (Belt_Map.isEmpty(emptyMap)) {
    return Belt_MapString.remove(smartcutLoginsByHostnameAndScenario, hostname);
  } else {
    return Belt_MapString.set(smartcutLoginsByHostnameAndScenario, hostname, emptyMap);
  }
}

var ByHostnameAndScenario = {
  t__encode: t__encode,
  t__decode: t__decode,
  castFromMap: castFromMap,
  toRefsByHostnameAndScenario: toRefsByHostnameAndScenario,
  empty: undefined,
  isEmpty: isEmpty,
  minify: minify$1,
  hasAnyLoginSmartcuts: hasAnyLoginSmartcuts,
  hasNoLoginSmartcutsForHostname: hasNoLoginSmartcutsForHostname,
  getHostnames: Belt_MapString.keysToArray,
  getHostnamesWithAtLeastOneLoginSmartcut: getHostnamesWithAtLeastOneLoginSmartcut,
  prependCommandsToCommandLog: prependCommandsToCommandLog,
  getPairsOfLoginScenarioAndLoginSmartcutForHostname: getPairsOfLoginScenarioAndLoginSmartcutForHostname,
  reduce: reduce,
  removeLoginSmartcutForHostname: removeLoginSmartcutForHostname
};

function t_encode$3(v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_encode, t_encode$2), v);
}

function t_decode$3(v) {
  return CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(Curry._1(CustomMap$SmartcutsMacros.MapLoginScenario.t_decode, t_decode$2), v);
}

function hydrate(loginSmartcutRefsByHostnameAndScenario, loginSmartcuts) {
  return Curry._1(castFromMap, Belt_MapString.map(loginSmartcutRefsByHostnameAndScenario, (function (mapLoginScenario) {
                    return CustomMap$SmartcutsMacros.MapLoginScenario.keepMap(mapLoginScenario, (function (loginScenario, param) {
                                  var loginBeforeStepIds = param.loginBeforeStepIds;
                                  var smartcutOrInstalledSmartcutPointer = param.smartcutOrInstalledSmartcutPointer;
                                  return ArrayUtils$SmartcutsMacros.shortcut((function (param) {
                                                var match = param[1];
                                                var commandLogData = match.commandLogData;
                                                if (commandLogData.TAG === /* Decoded */0 && Caml_obj.caml_equal(param[0], smartcutOrInstalledSmartcutPointer)) {
                                                  return [
                                                          loginScenario,
                                                          {
                                                            loginBeforeStepIds: loginBeforeStepIds,
                                                            smartcutOrInstalledSmartcutPointer: smartcutOrInstalledSmartcutPointer,
                                                            smartcutName: match.smartcutName,
                                                            commandLog: commandLogData._0
                                                          }
                                                        ];
                                                }
                                                
                                              }), loginSmartcuts);
                                }));
                  })));
}

var RefsByHostnameAndScenario = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  hydrate: hydrate
};

exports.SmartcutOrInstalledSmartcutPointer = SmartcutOrInstalledSmartcutPointer;
exports.t_encode = t_encode$1;
exports.t_decode = t_decode$1;
exports.minify = minify;
exports.SmartcutNameAndCommandLogData = SmartcutNameAndCommandLogData;
exports.Ref = Ref;
exports.toRef = toRef;
exports.ByHostnameAndScenario = ByHostnameAndScenario;
exports.RefsByHostnameAndScenario = RefsByHostnameAndScenario;
/* CustomMap-SmartcutsMacros Not a pure module */
